import { apiClient } from './client';

export async function getSetupWizardOverview() {
  const { data } = await apiClient.get('/api/system/setup-wizard/overview');
  return data;
}

export async function getSetupWizardSessions(params = {}) {
  const { data } = await apiClient.get('/api/system/setup-wizard/sessions', { params });
  return data;
}

export async function getSetupWizardEvents(params = {}) {
  const { data } = await apiClient.get('/api/system/setup-wizard/events', { params });
  return data;
}

export async function getTenantSetupContext(tenantId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/setup-context`);
  return data;
}

export async function getTenantSetupSession(tenantId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/setup-session`);
  return data;
}

export async function createTenantSetupSession(tenantId) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/setup-session`);
  return data;
}

export async function startTenantSetupSession(tenantId) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/setup-session/start`);
  return data;
}

export async function completeTenantSetupSession(tenantId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/setup-session/complete`, payload);
  return data;
}

export async function reopenTenantSetupSession(tenantId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/setup-session/reopen`, payload);
  return data;
}

export async function getTenantSetupSteps(tenantId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/setup-steps`);
  return data;
}

export async function completeTenantSetupStep(tenantId, stepCode, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/setup-steps/${stepCode}/complete`, payload);
  return data;
}

export async function skipTenantSetupStep(tenantId, stepCode, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/setup-steps/${stepCode}/skip`, payload);
  return data;
}

export async function blockTenantSetupStep(tenantId, stepCode, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/setup-steps/${stepCode}/block`, payload);
  return data;
}

export async function getTenantSetupEvents(tenantId, params = {}) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/setup-events`, { params });
  return data;
}

export async function getCustomerPortalTenantSetupContext(customerId, tenantId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/tenants/${tenantId}/setup-context`);
  return data;
}

export async function getCustomerPortalTenantSetupSession(customerId, tenantId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/tenants/${tenantId}/setup-session`);
  return data;
}
